import { css } from 'styled-components';

import { INPUT_BORDER_WIDTH_PX } from '../constants';

import getThemeInputVariant from './getThemeInputVariant';

const defaultBorderStyles = css(({ theme }) => {
  const variant = getThemeInputVariant(theme);

  return `
    border: ${INPUT_BORDER_WIDTH_PX} solid ${variant['border-default']};

    &:hover {
      border-color: ${variant['border-hover']};
    }

    &:focus-within {
      border-color: ${variant['border-focus']};
      /** note: we use outline instead of border 2px in order to prevent potential layout shifting due to 1px -> 2px border width change */
      outline: 1px solid ${variant['border-focus']};

      /** note: box shadow is 4px in design, but we add 1px more because of outline */
      box-shadow: 0 0 0 5px ${variant.shadow};
    }
  `;
});

const errorBorderStyles = css(({ theme }) => {
  const variant = getThemeInputVariant(theme);

  return `
    border: ${INPUT_BORDER_WIDTH_PX} solid ${variant['border-error']};
    outline: 1px solid ${variant['border-error']};

    &:focus-within {
      border-color: ${variant['border-focus']};
      /** note: we use outline instead of border 2px in order to prevent potential layout shifting due to 1px -> 2px border width change */
      outline: 1px solid ${variant['border-focus']};

      /** note: box shadow is 4px in design, but we add 1px more because of outline */
      box-shadow: 0 0 0 5px ${variant.shadow};
    }
  `;
});

const disabledBorderStyles = css(({ theme }) => {
  const variant = getThemeInputVariant(theme);

  return `
    border: ${INPUT_BORDER_WIDTH_PX} solid ${variant['border-default']};
  `;
});

type Props = {
  isDisabled: boolean | undefined;
  hasError: boolean | undefined;
};

const getInputBorderStyles = ({ isDisabled, hasError }: Props) => {
  if (isDisabled) return disabledBorderStyles;
  if (hasError) return errorBorderStyles;

  return defaultBorderStyles;
};

export default getInputBorderStyles;
